export default __webpack_public_path__ + "static/media/landing-background.bc50e450.jpg";